import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Client } from '../_models/client.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from 'src/environments/environment';

@Injectable()
export class ClientService {
  private authToken;
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  private static getClientsListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}&is_active=${filter.isActive}`;
    } else {
      if (filter.name) fromString += `&name_has=${filter.name}`;
      if (filter.email) fromString += `&email_has=${filter.email}`;
      if (filter.client_class) fromString += `&class_has=${filter.client_class}`;
      if (filter.domain) fromString += `&domain_has=${filter.domain}`;
      if (filter.fax) fromString += `&fax_has=${filter.fax}`;
      if (filter.cell_phone) fromString += `&phone_has=${filter.cell_phone}`;
      if (filter.isActive) fromString += `&is_active=${filter.isActive}`;
    }

    return fromString;
  }

  createClient(_client: Client) {
    const url = `${environment.CORE_BASE}/companies/${this.companyId}/clients`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<Client>(url, _client, { headers });
  }

  findClients(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const params = new HttpParams({
      fromString: ClientService.getClientsListQueryString(queryParams),
    });

    return this.http.get<QueryResultsModel>(
      `${environment.CORE_BASE}/companies/${this.companyId}/clients`,
      { params },
    );
  }

  updateClient(_client: Client): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.companyId}/clients/${_client.id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<Client>(url, _client, { headers });
  }

  
  deleteClient(clientId: number): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.companyId}/clients/${clientId}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers });
  }

  searchClients(term: string): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.companyId}/clients`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams({ fromString: 'search_term=' + term });
    return this.http.get<QueryResultsModel>(url, { headers, params });
  }
}
